export const sectionFormatOptions = [
  {
    title: 'HPI',
    type: 'hpi',
    options: [
      { label: 'Prose', value: 'prose' },
      { label: 'Bulleted', value: 'bulleted' },
      { label: 'Problem-Focused', value: 'problem_focused' },
    ],
  },
  {
    title: 'Subjective',
    type: 'subjective',
    options: [
      { label: 'Prose', value: 'prose' },
      { label: 'Bulleted', value: 'bulleted' },
      { label: 'Problem-Focused', value: 'problem_focused' },
    ],
  },
];

export const assessmentFormatOptions = [
  { label: 'Problem-Focused', value: 'problem_focused' },
  { label: 'Narrative', value: 'generic' },
];

export const tooltips = {
  assessment: {
    problem_focused: (
      <div>
        <p>
          Organized by individual problems with detailed analysis for each
          condition.
        </p>
      </div>
    ),
    generic: (
      <div>
        <p>
          A continuous narrative format covering all conditions and findings.
        </p>
      </div>
    ),
  },
  sectionFormat: {
    prose: (
      <div>
        <p>
          Continuous narrative format with complete sentences and paragraphs.
        </p>
      </div>
    ),
    bulleted: (
      <div>
        <p>A list of concise, organized points.</p>
      </div>
    ),
    problem_focused: (
      <div>
        <p>
          Organized by individual problems with detailed analysis for each
          condition.
        </p>
      </div>
    ),
  },
  icd10: {
    title:
      'When enabled, ICD-10 codes will be automatically prefixed in the Assessment section of your notes',
  },
  specialty: {
    title:
      'Selecting your specialty will help tailor your notes with relevant terminology and formatting preferences',
  },
};
